// src/pages/Home/components/Navbar3/ui/NotificationBadge.jsx

import React from "react";

import {
  cx,
  formatBadgeCount,
} from "../utils/navbar3.utils";

export default function NotificationBadge({
  count,
  compact = false,
  className = "",
}) {
  const numericCount =
    Number(count) || 0;

  if (numericCount <= 0) {
    return null;
  }

  return (
    <span
      className={cx(
        [
          "absolute",
          "inline-flex",
          "items-center",
          "justify-center",
          "rounded-full",
          "bg-red-600",
          "font-semibold",
          "leading-none",
          "text-white",
          "shadow-md",
          "shadow-red-950/30",
          "ring-2",
          "ring-neutral-800",
        ].join(" "),
        compact
          ? [
              "-right-1.5",
              "-top-1.5",
              "min-h-[17px]",
              "min-w-[17px]",
              "px-1",
              "text-[9px]",
            ].join(" ")
          : [
              "-right-2",
              "-top-2",
              "min-h-5",
              "min-w-5",
              "px-1",
              "text-[10px]",
            ].join(" "),
        className,
      )}
    >
      {formatBadgeCount(
        numericCount,
      )}
    </span>
  );
}